/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbRespTradeSourcingBanner_user$ref = any;
export type SbRespTradeSourcingBanner_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": SbRespTradeSourcingBanner_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespTradeSourcingBanner_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '586c982215b6e1a9d0efc8670c337f7a';
export default node;
